<template>
  <b-col
    cols="3"
    lg="2"
    class="tree right-bordered p-0"
  >
    <b-row class="py-1 tree-content-incidents">
      <b-col class="pl-4 pr-1">
        <div
          v-if="laboratorySelectedName"
          qa="center-block-tree"
          class="element patient"
        >
          <div class="single-patient">
            <b-button class="d-flex justify-content-between attach-pressed">
              <div
                class="d-flex"
                style="width: 90%;"
              >
                <i
                  class="fa fa-hospital mr-3"
                  style="margin-top: 2px"
                  aria-hidden="true"
                />
                <span>{{ laboratorySelectedName }}</span>
              </div>
            </b-button>
          </div>
        </div>

        <div
          v-if="hierarchicalPatientTree"
          qa="patient-block-tree"
          class="element patient"
        >
          <div class="single-patient">
            <b-button
              class="d-flex justify-content-between"
              :class="{'attach-pressed': hierarchicalPatientTree.selected}"
            >
              <div
                class="d-flex align-items-center"
                style="width: 90%;"
                @click="selectElement(hierarchicalPatientTree, {patId: hierarchicalPatientTree.patId, label: hierarchicalPatientTree.personIdentifier, incidentsCount: hierarchicalPatientTree.incidentsCount, type: 'PATIENT', icon: 'far fa-user'})"
              >
                <i
                  class="far fa-user primary-dark-color mr-3"
                  aria-hidden="true"
                />
                <span qa="patient-identifier">{{ hierarchicalPatientTree.personIdentifier }}</span>
                <vtBubble
                  v-if="hierarchicalPatientTree.incidentsCount"
                  :number="hierarchicalPatientTree.incidentsCount"
                  :type="true"
                  :tooltip="` ${$tc('global.incident', hierarchicalPatientTree.incidentsCount)}`"
                  style="margin-top: 2px"
                />
              </div>
              <div
                v-if="hierarchicalPatientTree.cases && hierarchicalPatientTree.cases.length"
                class="attach-arrow"
                @click="hideShowElement(hierarchicalPatientTree)"
              >
                <i
                  v-show="hierarchicalPatientTree.hide"
                  class="far fa-chevron-down"
                  aria-hidden="true"
                />
                <i
                  v-show="!hierarchicalPatientTree.hide"
                  class="far fa-chevron-up"
                  aria-hidden="true"
                />
              </div>
            </b-button>

            <!--Requests-->

            <div
              v-if="hierarchicalPatientTree.requests && hierarchicalPatientTree.requests.length"
              class="element cases ml-2"
              :class="{'attach-display': hierarchicalPatientTree.hide}"
              qa="request-item"
            >
              <div
                v-for="(itemRequest, index) in hierarchicalPatientTree.requests"
                :key="index"
                class="single-case"
              >
                <b-button
                  :ref="itemRequest.label"
                  class="d-flex justify-content-between"
                  :class="{'attach-pressed': itemRequest.selected}"
                >
                  <div
                    class="d-flex align-items-center auto-width"
                    @click="selectElement(itemRequest, {requestId: itemRequest.id, label: itemRequest.label, incidentsCount: itemRequest.incidentsCount, type: 'REQUEST', icon: 'fal fa-file-medical'})"
                  >
                    <i
                      class="fal fa-file-medical primary-dark-color mr-2"
                      aria-hidden="true"
                    />
                    <span qa="request-label">{{ itemRequest.label }}</span>
                    <vtBubble
                      v-if="itemRequest.incidentsCount"
                      :number="itemRequest.incidentsCount"
                      :type="true"
                      :tooltip="` ${$tc('global.incident', itemRequest.incidentsCount)}`"
                      style="margin-top: 2px"
                    />
                  </div>
                </b-button>
              </div>
            </div>

            <!--Cases-->
            <div
              v-if="hierarchicalPatientTree.cases && hierarchicalPatientTree.cases.length"
              class="element cases"
              :class="{'attach-display': hierarchicalPatientTree.hide}"
            >
              <div
                v-for="(itemCase, index) in hierarchicalPatientTree.cases"
                :key="index"
                class="single-case"
              >
                <div>
                  <hr class="my-0 mb-1 case-separator">
                </div>
                <b-button
                  :ref="itemCase.casCasenumber"
                  class="d-flex justify-content-between"
                  :class="{'attach-pressed': itemCase.selected}"
                >
                  <div
                    class="d-flex align-items-center flex-fill"
                    @click="selectElement(itemCase, {casId: itemCase.casId, label: itemCase.casCasenumber, incidentsCount: itemCase.incidentsCount, type: 'CASE', icon: 'far fa-chart-network', metadata: itemCase.metadata})"
                  >
                    <i
                      class="far fa-chart-network primary-dark-color mr-2"
                      aria-hidden="true"
                    />
                    <span>{{ itemCase.casCasenumber }}</span>
                    <vtBubble
                      v-if="itemCase.incidentsCount"
                      :number="itemCase.incidentsCount"
                      :type="true"
                      :tooltip="` ${$tc('global.incident', itemCase.incidentsCount)}`"
                      style="margin-top: 2px"
                    />
                  </div>
                  <div
                    v-show="itemCase.samples && itemCase.samples.length"
                    class="attach-arrow"
                    @click="hideShowElement(itemCase)"
                  >
                    <i
                      v-show="itemCase.hide"
                      class="far fa-chevron-down"
                      aria-hidden="true"
                    />
                    <i
                      v-show="!itemCase.hide"
                      class="far fa-chevron-up"
                      aria-hidden="true"
                    />
                  </div>
                </b-button>
                <!--Samples-->
                <div
                  v-if="itemCase.samples && itemCase.samples.length"
                  class="element samples ml-2"
                  :class="{'attach-display': itemCase.hide}"
                >
                  <div
                    v-for="(sample, indexSample) in itemCase.samples"
                    :key="indexSample"
                    class="single-sample"
                  >
                    <b-button
                      :ref="sample.samLabel"
                      class="d-flex justify-content-between"
                      :class="{'attach-pressed': sample.selected }"
                    >
                      <div
                        class="d-flex align-items-center flex-fill"
                        @click="selectElement(sample, {casId: itemCase.casId ,samId: sample.samId ,label: sample.samLabel, incidentsCount: sample.incidentsCount, type: 'SAMPLE', icon: 'far fa-prescription-bottle', metadata: sample.metadata})"
                      >
                        <i
                          class="far fa-prescription-bottle primary-dark-color mr-2"
                          aria-hidden="true"
                        />
                        <span>{{ sample.samSampleNumber }}</span>
                        <vtBubble
                          v-if="sample.incidentsCount"
                          :number="sample.incidentsCount"
                          :type="true"
                          :tooltip="` ${$tc('global.incident', sample.incidentsCount)}`"
                          style="margin-top: 2px"
                        />
                      </div>
                      <div
                        v-show="sample.portions && sample.portions.length"
                        class="attach-arrow"
                        @click="hideShowElement(sample)"
                      >
                        <i
                          v-show="sample.hide"
                          class="far fa-chevron-down"
                          aria-hidden="true"
                        />
                        <i
                          v-show="!sample.hide"
                          class="far fa-chevron-up"
                          aria-hidden="true"
                        />
                      </div>
                    </b-button>

                    <!--Portions-->
                    <div
                      v-if="sample.portions && sample.portions.length"
                      class="element portions ml-2"
                      :class="{'attach-display': sample.hide}"
                    >
                      <div
                        v-for="(portion, indexPortion) in sample.portions"
                        :key="indexPortion"
                        class="single-portion"
                      >
                        {{ portion.icon }}
                        <b-button
                          :ref="portion.porLabel"
                          class="d-flex justify-content-between"
                          :class="{'attach-pressed': portion.selected}"
                        >
                          <div
                            class="d-flex align-items-center flex-fill"
                            @click="selectElement(portion, {casId: itemCase.casId ,samId: sample.samId, porId: portion.porId, label: portion.porLabel, incidentsCount: portion.incidentsCount, type: 'PORTION', icon: PORTION_TYPES[portion.portionType.portionTypeEnum].icon, metadata: portion.metadata})"
                          >
                            <i
                              :class="PORTION_TYPES[portion.portionType.portionTypeEnum].icon"
                              class="primary-dark-color mr-2"
                              aria-hidden="true"
                            />
                            <span>{{ `${sample.samSampleNumber}-${ portion.porPortionnumber}` }}</span>
                            <vtBubble
                              v-if="portion.incidentsCount"
                              :number="portion.incidentsCount"
                              :type="true"
                              :tooltip="` ${$tc('global.incident', portion.incidentsCount)}`"
                              style="margin-top: 2px"
                            />
                          </div>
                          <div
                            v-show="portion.subportions && portion.subportions.length"
                            class="attach-arrow"
                            @click="hideShowElement(portion)"
                          >
                            <i
                              v-show="portion.hide"
                              class="far fa-chevron-down"
                              aria-hidden="true"
                            />
                            <i
                              v-show="!portion.hide"
                              class="far fa-chevron-up"
                              aria-hidden="true"
                            />
                          </div>
                        </b-button>
                        <!--Subportions-->
                        <div
                          v-if="portion.subportions && portion.subportions.length"
                          class="element subportions ml-2"
                          :class="{'attach-display': portion.hide}"
                        >
                          <div
                            v-for="(subportion, indexSubportion) in portion.subportions"
                            :key="indexSubportion"
                            class="single-portion"
                          >
                            <b-button
                              :ref="subportion.supLabel"
                              class="d-flex align-items-center flex-fill"
                              :class="{'attach-pressed': subportion.selected}"
                              @click="selectElement(subportion, {casId: itemCase.casId ,samId: sample.samId, porId: portion.porId, supId: subportion.supId, label: subportion.supLabel, incidentsCount: subportion.incidentsCount, type: 'SUBPORTION', icon: 'icon-porta', metadata: subportion.metadata})"
                            >
                              <i
                                class="icon-porta primary-dark-color mr-2"
                                aria-hidden="true"
                              />
                              <span>{{ `${sample.samSampleNumber}-${ portion.porPortionnumber}-${subportion.supSubportionnumber}` }}</span>
                              <vtBubble
                                v-if="subportion.incidentsCount"
                                :number="subportion.incidentsCount"
                                :type="true"
                                :tooltip="` ${$tc('global.incident', subportion.incidentsCount)}`"
                                style="margin-top: 2px"
                              />
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> <!--Patient End-->
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import VtBubble from '@/components/common/VtBubble'
import patientAttachmentService from '@/api/resources/attachment/patientAttachmentService'
import { COREENTITY_VALUES } from '@/api/resources/incident/incidentServices'
import { StoreUtils } from '@/shared/util/store-utils'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'

export default {
    name: 'HierarchicalPatientTree',
    components: {
        VtBubble
    },
    data() {
        return {
            itemSelected: null,
            selectView: false,
            animate: false,
            showAttach: false,
            showArrow: false,
            btnPressed: false,
            hideCases: false,
            hideSamples: false,
            hidePortions: false,
            hideSubportions: false,
            hierarchicalPatientTree: null,
            laboratorySelectedName: null,
            selecteInformation: null,
            isRequest: false,
            isGeneral: false
        }
    },
    computed: {
        PORTION_TYPES() {
            return PORTION_TYPES
        }
    },
    methods: {
        hideShowElement(item) {
            item.hide = !item.hide
            this.$forceUpdate()
        },
        selectElement(item, information) {
            this.$emit('itemSelected', information)
            if (this.itemSelected) this.itemSelected.selected = false
            this.itemSelected = item
            this.itemSelected.selected = !this.itemSelected.selected
            this.selectedInformation = information
            this.$forceUpdate()
        },
        async reloadTree() {
            const defaultOption = this.selectedInformation
            defaultOption.coreEntity = this.selectedInformation.type
            await this.loadTree(this.hierarchicalPatientTree.patId, defaultOption, this.isRequest, this.isGeneral)
        },
        async loadTree(patId, defaultOption, isRequest, isGeneral) {
            this.isRequest = isRequest
            this.isGeneral = isGeneral
            if (isGeneral) {
                this.laboratorySelectedName = StoreUtils.selectedLaboratoryConfiguration?.laboratory.labName
                return
            }
            this.updateLoading(true)
            const withAttachments = false
            const withIncidents = true
            let [err, response] = await this.toCall(patientAttachmentService.getAttachmentPatientTree(this.$store.getters.labId, patId, withAttachments, withIncidents, isRequest))
            if (err) {
                this.showErrorModalGlobal()
            } else {
                this.hierarchicalPatientTree = response
                if (!defaultOption || defaultOption.coreEntity === COREENTITY_VALUES.PATIENT.code) {
                    this.selectElement(this.hierarchicalPatientTree, {
                        patId: this.hierarchicalPatientTree.patId,
                        label: this.hierarchicalPatientTree.personIdentifier,
                        incidentsCount: this.hierarchicalPatientTree.incidentsCount,
                        type: 'PATIENT',
                        icon: 'far fa-user'
                    })
                } else {
                    switch (defaultOption.coreEntity) {
                    case COREENTITY_VALUES.REQUEST.code:
                        {
                            const selectedRequest = this.hierarchicalPatientTree.requests?.find(request => request.id === defaultOption.requestId)
                            if (selectedRequest) {
                                this.selectElement(selectedRequest, {
                                    requestId: selectedRequest.id,
                                    label: selectedRequest.label,
                                    incidentsCount: selectedRequest.incidentsCount,
                                    metadata: selectedRequest.metadata,
                                    type: 'REQUEST',
                                    icon: 'fal fa-file-medical'
                                })
                                this.scrollElementIntoView(selectedRequest.label)
                            }
                        }
                        break
                    case COREENTITY_VALUES.CASE.code:
                        {
                            const selectedCase = this.hierarchicalPatientTree.cases?.find(caseStudy => caseStudy.casId === defaultOption.casId)
                            if (selectedCase) {
                                this.selectElement(selectedCase, {
                                    casId: selectedCase.casId,
                                    label: selectedCase.casCasenumber,
                                    incidentsCount: selectedCase.incidentsCount,
                                    metadata: selectedCase.metadata,
                                    type: 'CASE',
                                    icon: 'far fa-chart-network'
                                })
                                this.scrollElementIntoView(selectedCase.casCasenumber)
                            }
                        }
                        break
                    case COREENTITY_VALUES.SAMPLE.code:
                        {
                            const selectedCase = this.hierarchicalPatientTree.cases?.find(caseStudy => caseStudy.casId === defaultOption.casId)
                            const selectedSample = selectedCase?.samples?.find(sample => sample.samId === defaultOption.samId)
                            if (selectedSample) {
                                this.selectElement(selectedSample, {
                                    casId: defaultOption.casId,
                                    samId: defaultOption.samId,
                                    label: selectedSample.samLabel,
                                    incidentsCount: selectedSample.incidentsCount,
                                    metadata: selectedSample.metadata,
                                    type: 'SAMPLE',
                                    icon: 'far fa-prescription-bottle'
                                })
                                this.scrollElementIntoView(selectedSample.samLabel)
                            }
                        }
                        break
                    case COREENTITY_VALUES.PORTION.code:
                        {
                            const selectedCase = this.hierarchicalPatientTree.cases?.find(caseStudy => caseStudy.casId === defaultOption.casId)
                            const selectedSample = selectedCase?.samples?.find(sample => sample.samId === defaultOption.samId)
                            const selectedPortion = selectedSample?.portions?.find((portion) => portion.porId === defaultOption.porId)
                            if (selectedPortion) {
                                this.selectElement(selectedPortion, {
                                    porId: defaultOption.porId,
                                    casId: defaultOption.casId,
                                    samId: defaultOption.samId,
                                    label: selectedPortion.porLabel,
                                    incidentsCount: selectedPortion.incidentsCount,
                                    metadata: selectedPortion.metadata,
                                    type: 'PORTION',
                                    icon: defaultOption.icon
                                })
                                this.scrollElementIntoView(selectedPortion.porLabel)
                            }
                        }
                        break
                    case COREENTITY_VALUES.SUBPORTION.code:
                        {
                            const selectedCase = this.hierarchicalPatientTree.cases?.find(caseStudy => caseStudy.casId === defaultOption.casId)
                            const selectedSample = selectedCase?.samples?.find(sample => sample.samId === defaultOption.samId)
                            const selectedPortion = selectedSample?.portions?.find((portion) => portion.porId === defaultOption.porId)
                            const selectedSubportion = selectedPortion?.subportions?.find((sup) => sup.supId === defaultOption.supId)
                            if (selectedSubportion) {
                                this.selectElement(selectedSubportion, {
                                    supId: defaultOption.supId,
                                    porId: defaultOption.porId,
                                    casId: defaultOption.casId,
                                    samId: defaultOption.samId,
                                    label: selectedSubportion.supLabel,
                                    incidentsCount: selectedSubportion.incidentsCount,
                                    metadata: selectedSubportion.metadata,
                                    type: 'SUBPORTION',
                                    icon: 'icon-porta'
                                })
                                this.scrollElementIntoView(selectedSubportion.supLabel)
                            }
                        }
                        break
                    }
                }
            }
            this.updateLoading(false)
        },
        scrollElementIntoView(id) {
            this.$nextTick(() => {
                if (this.$refs[id]) {
                    this.$refs[id][0].scrollIntoView()
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  .incidentsModal .tree {
    border-right: 1px solid #dee2e6;
    background: vt-color(base-text,.90);
  }

  .incidentsModal .attach-header {
    border-bottom: 1px solid #dee2e6;
  }

  .incidentsModal .attach-content {
    height: calc(100vh - 235px);
      min-height: 400px;
      overflow: hidden;
    overflow-y: auto;
    margin-right: 5px;
  }

  .incidentsModal .tree-content-incidents {
    height: calc(100vh - 150px);
      min-height: 400px;
      overflow: hidden;
    overflow-y: auto;
    margin-right: 0;
  }

  .incidentsModal .tree .element .btn {
    background: vt-color(white-light);
    color: vt-color(dark-text);
    border-color: #dee2e6;
    border-radius: 2px;
    width: 100%;
    margin-bottom: 5px;
    box-shadow: 0 1px 1px 0 vt-color(base-text, .7);
    font-size: font-size(very-small);
  }

  .incidentsModal .tree .element .btn .attach-arrow i:hover {
    color: vt-color(primary);
  }

  .incidentsModal .tree .element .btn .attach-arrow i {
    color: vt-color(base-text);
    font-size: font-size(tiny);
  }

  .incidentsModal .tree .element .arrow {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: .9rem;
  }

  .incidentsModal .tree .element .btn:hover {
    background: vt-color(light-primary);
    border-color: vt-color(alt-primary, .5);
  }

  .attach-arrow {
    padding: 0 3px;
  }

  .attach-display {
    display: none;
  }

  .attach-pressed {
    background: vt-color(primary) !important;
    border-radius: 3px !important;
    color: #FFF !important;
  }

  .attach-pressed i {
    color: #FFF !important;
  }

  .case-separator{
    border-top: 2px solid vt-color(base-text, .7);
  }

  .incidentsModal .sidepanel {
    border-left: 1px solid #dee2e6;
    background: #FFF;
    width: 300px;
    position: absolute;
    right: -300px;
    height: 100%;
    transition: .3s;
    box-shadow: 0 3px 5px 0 #9c9c9c;
  }

  .incidentsModal .sidepanel.animation {
    right: 0;
  }

  .incidentsModal .sidepanel .header {
    border-bottom: 1px solid #dee2e6;
  }

  .incidentsModal .sidepanel .title {
    color: vt-color(primary);
  }

  .incidentsModal .sidepanel .content {
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;
  }

  .incidentsModal .sidepanel .file {
    border-bottom: 1px solid #dee2e6;
  }

  .incidentsModal .sidepanel .file .others {
    color: grey;
    font-size: .9rem;
  }

  .incidentsModal .sidepanel .element .col-md-4 {
    max-width: 100% !important;
    padding-left: 10px;
    margin-top: 5px;
    margin-bottom: 0 !important;
  }

    .tree-content-incidents span {
        @include text-truncate();
    }
</style>
